import { apiSlice } from './apiSlice'

/** Mirrors FastAPI `QualitySamplingOut` (camelCase aliases) — frmQualityQrySampling datasheet. */
export interface QualitySampling {
  id: number
  sampleNo: string | null
  psDate: string | null
  psSentDate: string | null
  tlcContractRef: string | null
  doNo: string | null
  warehouseCode: string | null
  whSamplingName: string | null
  lotId: string | null
  clientLotId: string | null
  origin: string | null
  lotSizeMt: number | null
  weightPerContMt: number | null
  licenseCertNo: string | null
  certUnit: string | null
  qtyPreshipmentClient: number | null
  qtyPreshipmentSupervisor: number | null
  cost: number | null
  qtyAftershipmentClient: number | null
  qtyAftershipmentSupervisor: number | null
  receiver: string | null
  receivingAuthority: string | null
  inspectionBy: string | null
  sealNo: string | null
  note: string | null
  resultReceiptDate: string | null
  result: string | null
  rejectReason: string | null
  clientSampleRef: string | null
  note2: string | null
  createdDate: string | null
  updatedDate: string | null
  createdBy: string | null
  updatedBy: string | null
  isStatus: number | null
  loadingType: string | null
  grade: string | null
  buyersRef: string | null
  deliveryTo: string | null
  quality: string | null
  certification: string | null
  cpCode: string | null
  txtfullLotNo: string | null
  loadingDate: string | null
  consignee: string | null
  fumigationNote: string | null
  sampleType: string | null
  consigneeOptional: string | null
  consigneeOptionalName: string | null
  txtBuyer: string | null
  sQuantity: number | null
  sPackage: string | null
  sPackageName: string | null
  alertTxt: string | null
  sampleStatus: string | null
  statusDate: string | null
  statusReason: string | null
}

export interface QualitySamplingListResponse {
  items: QualitySampling[]
  total: number
  page: number
  pageSize: number
}

export interface QualitySamplingListQuery {
  page: number
  pageSize: number
  dateFrom?: string
  dateTo?: string
}

const qualitySamplingApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getQualitySamplings: builder.query<QualitySamplingListResponse, QualitySamplingListQuery>({
      query: ({ page, pageSize, dateFrom, dateTo }) => ({
        url: '/quality-samplings',
        params: {
          page,
          pageSize,
          ...(dateFrom ? { dateFrom } : {}),
          ...(dateTo ? { dateTo } : {}),
        },
      }),
      providesTags: ['QualitySampling'],
    }),

    deleteQualitySampling: builder.mutation<{ message: string }, number>({
      query: (id) => ({ url: `/quality-samplings/${id}`, method: 'DELETE' }),
      invalidatesTags: ['QualitySampling'],
    }),
  }),
})

export const {
  useGetQualitySamplingsQuery,
  useDeleteQualitySamplingMutation,
} = qualitySamplingApi

export default qualitySamplingApi
